import React, { ReactNode } from 'react';

import { Text, TextProps } from '@rover/kibble/core';

interface TruncatedTextProps extends TextProps {
  children: ReactNode;
}

/**
 * TruncatedText is a wrapper around Kibble's Text component that handles text overflow
 * with ellipsis. Commonly used for displaying text in constrained spaces where content
 * might exceed available width.
 *
 * @example
 * <TruncatedText size="100" textColor="primary">
 *   Very long text that will be truncated...
 * </TruncatedText>
 */
const TruncatedText: React.FC<TruncatedTextProps> = ({ children, sx = {}, ...props }) => {
  return (
    <Text
      sx={{
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        width: '100%',
        ...sx,
      }}
      {...props}
    >
      {children}
    </Text>
  );
};

export default TruncatedText;
